import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_LINK = createFcmDetails('membership_ppmu_offsite_link', {
	owner: /* TODO */ '',
	context: /* TODO */ '',
	description: `Link to navigate to when users accept to support Change through the PSF promote thank you membership ask modal.
		See also membership_ppmu_offsite_copy FCM.
`,
	import: false,
});
